<template>
    <div>
        <template v-if="viewPage == true">
            <div class="modal fade" id="needAttention" tabindex="-1" aria-labelledby="needAttention" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                            <span>&times;</span>
                        </button>
                        <div class="modal-body fields-map-popup">
                            <div class="popup-head mb-4">
                                <h2 class="pb-0"> Need your attention. </h2>
                                <p> Please, add or map them all. </p>
                            </div>
                            <div class="need-attention-content">
                            </div>
                            <div class="mt-4 text-right">
                                <button type="button" class="btn btn-primary" id="popupProcessButton">Proceed</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clearfix">
                <div class="page-top mb-1 mb-3 align-center clearfix">
                    <h1 class="float-left"> Retailer Payment Bulk Upload</h1>
                    <div class="progress-bar-holder">
                        <div class="progress step-one">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <ul class="prgress-number">
                            <li class="progress-number-list active">
						<span class="bullet">
							1
						</span>
                                <p> Upload </p>
                            </li>
                            <li class="progress-number-list" id="progressNumberListTwo">
						<span class="bullet">
							2
						</span>
                                <p> Field Mapping </p>
                            </li>
                        </ul>
                    </div>
                    <button class="btn btn-primary float-right mr-1" id="process_dropzone_queue" v-show="proceedButtonflag"> Proceed </button>
                    <router-link class="btn btn-primary float-right mr-1" to="/retailerPayment"> Cancel </router-link>
                </div>


                <div class="batch-upload-main">
                    <div class="batch-upload-inner">
                        <div class="upload-sheet" v-show="previewMapField == false">

                            <div class="form-group">
                                <input type="text" placeholder="What would you like to call this batch?" class="form-control" v-model="title" v-on:change="handleGeneratePayrollButton()" />
                            </div>
                            <div class="row align-items-center new-batch-payroll-type mb-4">
                                <div class="col-3">
                                    <label for="" class="label block-label"> Payment Type <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="Disbursement CSV run for one time or for a period of time."></i>
                                    </label>
                                </div>
                                <div class="col-3">
                                    <label class="radio-holder">
                                        For a period
                                        <input type="radio" v-model="payroll_frequency" checked value="TIMEPERIOD" @change="handleGeneratePayrollButton()">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="col-3">
                                    <label class="radio-holder">
                                        One time
                                        <input type="radio" v-model="payroll_frequency" value="ONETIME" @change="handleGeneratePayrollButton()">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>

                            </div>
                            <label for="" class="label block-label mb-4"> Payroll Period <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="This is a period against which a payment is made to employees, retailers or any other person."></i>
                            </label>
                            <div class="row mb-4">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <datepicker  @selected="handleGeneratePayrollButton()" @input="from_date = fixDate($event)" :disabledDates="disabledDates" v-model="from_date" input-class="datepicker" :clear-button="true" placeholder="From" :bootstrap-styling="true" v-show="payroll_frequency == 'TIMEPERIOD'"></datepicker>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <datepicker  @selected="handleGeneratePayrollButton()" @input="to_date = fixDate($event)" :disabledDates="disabledDates" v-model="to_date" :clear-button="true" placeholder="To" input-class="datepicker" :bootstrap-styling="true" v-show="payroll_frequency == 'TIMEPERIOD'"></datepicker>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <datepicker  @selected="handleGeneratePayrollButton()" @input="onetime_date = fixDate($event)" :disabledDates="disabledDates" v-model="onetime_date" :clear-button="true" placeholder="Onetime" input-class="datepicker" :bootstrap-styling="true" v-show="payroll_frequency == 'ONETIME'"></datepicker>
                                    </div>
                                </div>
                            </div>
                            <label for="" class="label block-label upload-label"> Upload a CSV <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title='".CSV" is a Microsoft Excel file format which is a requirement for Finja Business to read your file. Simple Excel file can be saved as a .CSV file using "save as" option listed under file menu on your Excel program.'></i>
                            </label>
<!--                            <p v-show="$global.user_company_payment_engine == 'EASY_PAISA'">Download a bank code template <a :href="`${$global.base_url}csv/BankCode`" target="_blank">here.</a> </p>-->
                            <p>Download a sample template <a :href="`${$global.aws_base_url}/csv/retailers.csv`" target="_blank">here</a>. </p>
                            <form  method="post" class="box dropzone drozone-label dz-clickable dropzone content mt-4" action="/upload" id="drop" data-toggle="tooltip" data-placement="left" title="<p class='align-left'>Following requirements in
                            order to upload employees
                            in Bulk: <br/>
							1. Mandatory fields : Mobile Number, Bank Code, Account Number,cnic<br/>
							2. Only add registered account numbers.<br/>
							3. Mobile numbers must be in the following format: 923XXXXXXXXX.<br/>
							4. Set the formatting of mobile number column to “Number” with zero decimal places.<br/>
							5. No repetition of column names.<br/>
							6. No empty cells in a valid row.<br/>
							7. No special characters in the sheet.</p>">

                                <div class="box__input dz-message">
                                    <label class="drozone-label" for="file">
                                        <img  id="uploadIcon" for="file" src="/images/svgs/upload-icon.svg" alt="" class="upload">
                                        <span for="file" class="filename"> Drop your file here </span>
                                    </label>
                                    <label class="uploadedFileName">Drop your file here</label>
                                </div>
                                <div class="disable-click" style="display: none;">
                                    <a class="cross" href="javascript:void(0)"><img style="cursor:pointer;" src="/images/cross.png" alt="Remove File" title="Remove File" /></a>
                                </div>
                            </form>
                            <em class="dropzone-or"> Or </em> <label id="selectFromComputer" class="btn btn-primary select-file-btn"> Select from your computer </label>
                        </div> <!-- upload sheet -->
                        <div class="previewMapField" v-show="previewMapField == true">
                            <div class="mandatory-fields mb-4">
                                <label for="" class="label block-label upload-label mb-3"> Mandatory Information <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="”Mandatory Information” contain fields that are required for Finja Business to process your sheet."></i> </label>
                                    <div class="mandatory-tags">
                                        <div class="mandatory-fields-inner">
                                        <div class="mandatory-field-col"> <span class="map-value" title="Mobile Number"> <i id="mand_mobile_number" v-show="mand_mobile_number" class="fas fa-check"></i> Mobile Number </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Account Type"> <i id="mand_account_type" v-show="mand_account_type" class="fas fa-check"></i> Account Type </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Bank Code"> <i id="mand_bank_code" v-show="mand_bank_code" class="fas fa-check"></i> Bank Code </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Account Number"> <i id="mand_account_number" v-show="mand_account_number" class="fas fa-check"></i> Account Number </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Net Payable"> <i id="mand_net_payable" v-show="mand_net_payable" class="fas fa-check"></i> Net Payable </span> </div>
                                    </div>
                                </div>
                            </div>
                            <label for="" class="label block-label upload-label"> Preview and map your identifiers <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="Please review the below identifiers in line with the columns in your sheet."></i>
                            </label>
                            <p> Please check if we have correctly picked your data. </p>
                            <div class="fields-mapping mt-4" id="fieldmapping_table">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="viewPage == null">
            <preLoader></preLoader>
        </template>
        <template v-if="viewPage == false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                viewPage : true,
                payroll_id : '',
                payroll : '',
                payrollType: '',

                mand_mobile_number : false,
                mand_bank_code : false,
                mand_account_type : false,
                mand_account_number : false,
                mand_net_payable : false,
                previewMapField : false,
                fileAdded : false,
                filecolumn : [],
                fileRowData : [],
                dropZoneObject : null,
                proceedButtonflag : false,
                payroll_frequency : 'ONETIME',
                from_date : '',
                to_date : '',
                onetime_date : '',
                title : '',
                disabledDates: {
                    from: new Date(Date.now())
                }
            }
        },
        methods: {
            fixDate(event){
                return moment(event).format('YYYY-MM-DD');
            },
            processDropzoneQueue(){

            },
            handleGeneratePayrollButton(){
                var flag = false;
               if(this.payroll_frequency == 'TIMEPERIOD' && this.from_date != '' && this.to_date != ''){
                    flag = true;
                }if(this.payroll_frequency == 'ONETIME' && this.onetime_date != ''){
                    flag = true;
                }
                if(flag == true && this.fileAdded == true){
                    if(this.isAPIAvailable()){
                        $.when(this.printTable(this.dropZoneObject.files[0]));
                    }
                }else{
                    if(this.fileAdded == true){
                        this.showToastBox('warning','Please select all values');
                    }
                }
            },
            initDropZone() {
                var that = this;
                Dropzone.options.drop = {
                    addRemoveLinks: true,
                    paramName: 'file',
                    maxFilesize: 2, // MB
                    uploadMultiple: false,
                    maxFiles: 1,
                    minFiles: 1,
                    queueLimit:1,
                    url: that.$global.base_url+'api/retailerPaymentBulkUpload',
                    acceptedFiles: '.csv',
                    autoProcessQueue:false,
                    timeout:0,
                    headers: window.axios.defaults.headers.common,
                    init: function(){
                        var _this = this;
                        that.dropZoneObject = this;
                        var selectedFile = document.getElementById('selectFromComputer');
                        selectedFile.addEventListener('click',function(){
                            _this.hiddenFileInput.click();
                        });
                        this.on("maxfilesexceeded", function(file) {
                            this.removeAllFiles();
                            this.addFile(file);
                        });
                        this.on('removedfile',function(file){
                            that.fileAdded = false;
                            $('div.box__input').show();
                        }),
                        this.on("addedfile", function(file) {
                            var ext = file.name.split('.')[1];
                            var invalid = 0;
                            if(ext != 'csv'){
                                that.showToastBox('error','Invalid file added');
                                this.removeFile(file);
                                return false;
                            }
                            that.fileAdded = true;
                            $('.disable-click').show();
                            that.checkFileForErrors(file);
                            that.handleGeneratePayrollButton();
                        });
                        var submitButton_top 	= document.querySelector("#process_dropzone_queue");
                        var popupProcessButton 	= document.querySelector("#popupProcessButton");
                        function processFileLocal(){
                            if(that.isAPIAvailable()){
                                $.when(that.printTable(that.dropZoneObject.files[0]));
                            }
                        }
                        function processQueueLocal(){
                            that.$Progress.start();
                            $('#process_dropzone_queue').prop('disabled',true);
                            $('#popupProcessButton').prop('disabled',true);
                            that.dropZoneObject.processQueue(); // Tell Dropzone to process all queued files.
                        }
                        submitButton_top.addEventListener("click", function(e) {
                            processQueueLocal();
                        });
                        popupProcessButton.addEventListener("click", function(e) {
                            processQueueLocal();
                        });
                        that.dropZoneObject.on("sending", function(file, xhr, formData) {
                            that.$Progress.start();
                            var mapIdentifier = [];
                            var selVal = '';
                            $( "select.selectpicker" ).each(function() {
                                selVal = $(this).find('option:selected').val();
                                mapIdentifier.push(selVal);
                                selVal = '';
                            });
                            formData.append("mapIdentifier", JSON.stringify(mapIdentifier));
                            formData.append("_token",$('meta[name="csrf-token"]').attr('content'));
                            formData.append("payroll_type", that.payroll_type);
                            formData.append("payroll_frequency", that.payroll_frequency);
                            formData.append("from_date", that.from_date);
                            formData.append("to_date", that.to_date);
                            formData.append("onetime_date", that.onetime_date);
                            formData.append("sheetName", that.title);
                            formData.append("payroll_id", that.payroll_id);
                            formData.append("title", that.title);
                        });

                        that.dropZoneObject.on("totaluploadprogress", function(progress) {

                        });

                        that.dropZoneObject.on("uploadprogress", function(file, progress, bytesSent) {
                            // Update progress bar with the value in the variable "progress", which
                            // is the % total upload progress from 0 to 100
                            var progressBar = Math.floor(progress);
                            if(progressBar == 100){
                                that.$Progress.finish();
                            }
                        });

                        that.dropZoneObject.on("success", function(file, obj) {
                            var msg = null;
                            if(obj.code == "200") {
                                toast.fire({
                                type: 'success',
                                title: 'Retailer Payment batch uploaded successfully'
                            });
                            that.$router.push('/retailerPayment');
                            }else if(obj.code == "2"){
                                msg = obj.message;
                            }else if(obj.code == "204"){
                                msg = obj.message;
                            }else if(obj.code == "301"){
                                msg = obj.message;
                            }else{
                                msg = obj.message;
                            }
                            if(msg !== null){
                                that.showAlertBox('error','Error in file',msg);
                            }
                        });
                        that.dropZoneObject.on('error',function(file,errorMessage,xhr){
                            if(!file.accepted){
                                fileAdded = false;
                                var error_message = $('div#wrongfilemessage').html();
                                that.showAlertBox('error','Error in file',error_message);
                                this.removeFile(file);
                            }
                            var msg = '<strong>Error:'+xhr.status+'</strong> '+xhr.statusText;
                            that.showAlertBox('error','Error in file', msg);
                            file.status = Dropzone.QUEUED;
                        });
                    }
                };
                $('.cross').on('click', function(e){
                    that.dropZoneObject.removeAllFiles();
                    $('.disable-click').hide();
                    $('label.uploadedFileName').html('Drop your file here');
                });
            },
            isAPIAvailable() {
                // Check for the various File API support.
                if (window.File && window.FileReader && window.FileList && window.Blob) {
                    // Great success! All the File APIs are supported.
                    return true;
                } else {
                    var error_message = 'The HTML5 APIs used in this form are only available in the following browsers:<br /> - Google Chrome: 13.0 or later<br /> - Mozilla Firefox: 6.0 or later<br /> - Internet Explorer: Not supported (partial support expected in 10.0)<br /> - Safari: Not supported<br /> - Opera: Not supported';
                    this.showAlertBox('error',error_message);
                    return false;
                }
            },
            printTable(file) {
                var cityRowid = 0;
                var reader = new FileReader();
                reader.readAsText(file);
                var that = this;
                reader.onload = function(event){
                    var csv = event.target.result;
                    var data = $.csv.toArrays(csv);
                    for(var row in data){
                        if(row > 0){
                            var _row = [];
                            if(data[row] != ""){
                                for(var item in data[row]){
                                    var value = data[row][item];
                                    _row.push(value);
                                }
                                that.fileRowData.push(_row);
                            }
                        }
                    }
                    var test 		= '';
                    var selected 	= '';
                    var col = [];
                    for(var row in data) {
                        if(row > 1) break;
                        for(var item in data[row]) {
                            if(row == 0){
                                col[item] = [data[row][item]];
                            }else{
                                col[item].push(data[row][item]);
                            }
                        }
                    }
                    for(var row1 in col) {
                        var rowName = '';
                        var rowValue = '';
                        var comboBox = '';
                        var fieldMap = false;
                        for(var item1 in col[row1]) {
                            if(item1 > 1){ break; }
                            if(item1 == 0){
                                rowName = col[row1][item1];
                            }else{
                                rowValue += '<p>' + col[row1][item1] + '</p>';
                            }
                        }
                        // check for if you find the Name in you ddList

                        if(rowName.trim().toLocaleLowerCase() == 'mobile number'){
                            that.mand_mobile_number = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'account type'){
                            that.mand_account_type = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'bank code'){
                            that.mand_bank_code = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'account number'){
                            that.mand_account_number = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'net payable'){
                            that.mand_net_payable = fieldMap = true;
                        }
                        comboBox += '<select name="'+row1+'" class="selectpicker show-menu-arrow custom-select2" data-size="5">';
                        comboBox += '<option value="do-not"> - Select - </option>';
                        comboBox += '<optgroup label="Retailer Detail">';
                        selected = (rowName.trim().toLocaleLowerCase() == 'name') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'name') ? true : fieldMap;
                        comboBox += '<option value="Name" '+selected+'>Name</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'mobile number') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'mobile number') ? true : fieldMap;
                        comboBox += '<option value="mobile number" '+selected+'>Mobile Number</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'account type') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'account type') ? true : fieldMap;
                        comboBox += '<option value="account type" '+selected+'>Account Type</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'bank code') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'bank code') ? true : fieldMap;
                        comboBox += '<option value="bank code" '+selected+'>Bank Code</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'account number') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'account number') ? true : fieldMap;
                        comboBox += '<option value="account number" '+selected+'>Account Number</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'purpose of payment') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'purpose of payment') ? true : fieldMap;
                        comboBox += '<option value="purpose of payment" '+selected+'>Purpose Of Payment</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'net payable') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'net payable') ? true : fieldMap;
                        comboBox += '<option value="net payable" '+selected+'>Net Payable</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'cnic') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'cnic') ? true : fieldMap;
                        comboBox += '<option value="cnic" '+selected+'>CNIC</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'ntn') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'ntn') ? true : fieldMap;
                        comboBox += '<option value="ntn" '+selected+'>NTN</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'email address') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'email address') ? true : fieldMap;
                        comboBox += '<option value="email address" '+selected+'>Email Address</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'outlet code') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'outlet code') ? true : fieldMap;
                        comboBox += '<option value="outlet code" '+selected+'>Outlet Code</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'region') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'region') ? true : fieldMap;
                        comboBox += '<option value="region" '+selected+'>Region</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'area') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'area') ? true : fieldMap;
                        comboBox += '<option value="area" '+selected+'>Area</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'channel') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'channel') ? true : fieldMap;
                        comboBox += '<option value="channel" '+selected+'>Channel</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'sub channel') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'sub channel') ? true : fieldMap;
                        comboBox += '<option value="sub channel" '+selected+'>Sub Channel</option>';
                        comboBox += '</optgroup>';
                        comboBox += '</select>';
                        if(fieldMap == true){
                            test += '<div class="row mapped align-items-center">';
                        }else{
                            test += '<div class="row align-items-center">';
                        }
                        test += '<div class="col-md-1"><div class="fields-mapping-inner"><i class="fas fa-check-circle"></i></div></div>';
                        test += '<div class="col-md-7"><div class="fields-mapping-inner"><p> '+rowName+' </p><p> '+rowValue+' </p></div></div>';
                        test += '<div class="col-md-4"><div class="fields-mapping-inner">';
                        test += comboBox;
                        test += '</div></div>';
                        test += '</div>';
                    }
                    $('#fieldmapping_table').html(test);
                    that.previewMapField = true;
                    that.generateButtonProccess();
                    $('select.selectpicker').selectpicker('refresh');
                    that.assignComboFunction();
                    $('div.progress').addClass('step-two');
                };
                reader.onerror = function(){ this.showAlertBox('error','Unable to read ' + file.fileName); }.bind(this);
            },
            generateButtonProccess(){
                if(this.mand_mobile_number == true && this.mand_bank_code && this.mand_account_type == true && this.mand_account_number == true && this.mand_net_payable==true){
                    this.proceedButtonflag = true;
                }else{
                    this.proceedButtonflag = false;
                }
            },
            checkForMandField(){
                var that = this;
                $( "select.selectpicker" ).each(function(index,value) {
                    if(index == 0){
                        that.mand_mobile_number = that.mand_bank_code = that.mand_account_type = that.mand_account_number = that.mand_net_payable = false;
                    }
                    var selVal = $(this).find('option:selected').val();
                    if(selVal.trim().toLowerCase() == 'mobile number') that.mand_mobile_number = true;
                    if(selVal.trim().toLowerCase() == 'bank code') that.mand_bank_code = true;
                    if(selVal.trim().toLowerCase() == 'account number') that.mand_account_number = true;
                    if(selVal.trim().toLowerCase() == 'account type') that.mand_account_type = true;
                    if(selVal.trim().toLowerCase() == 'net payable') that.mand_net_payable = true;
                });
            },
            assignComboFunction(){
                var that = this;
                // Auto Mapped value make disabled
                $('select.selectpicker').each(function(index,obj){
                    $('select.selectpicker option[value="'+obj.value+'"]').attr('disabled',true);
                });
                $(that.$el).find('.selectpicker').selectpicker('refresh');
                var previous;
                $('select.selectpicker').on('shown.bs.select',function(){
                    previous = this.value;
                }).change(function(){
                    var selVal = $(this).find('option:selected').val();
                    $('select.selectpicker option[value="'+previous+'"]').attr('disabled',false);
                    $('select.selectpicker option[value="'+selVal+'"]').attr('disabled',true);
                    $(that.$el).find('.selectpicker').selectpicker('refresh');
                    that.checkForMandField();
                    if(selVal !== 'do-not'){
                        $(this).parent().parent().parent().parent().addClass('mapped');
                    }else{
                        $(this).parent().parent().parent().parent().removeClass('mapped');
                    }
                    that.generateButtonProccess();
                });
            },
            customCombo(){
                // for c-val-displayer start
                $(".cstm-cmbx-w-adtn .c-val-displayer").unbind('click').click(function(){
                    var ref = $(this);
                    var popDiv =  $(this).parent().find(".val-overlyr");
                    var popper = new Popper(ref,popDiv,{
                        placement:'bottom-end',
                        gpuAcceleration:false
                    });
                    $(this).parent().find(".val-overlyr").toggleClass("activated");
                });
                // for c-val-displayer end
            },
            checkFileForErrors(file){
                var reader = new FileReader();
                reader.readAsText(file);
                var that = this;
                reader.onload = function(event){
                    var csv = event.target.result;
                    var data = $.csv.toArrays(csv);
                    var col = [];
                    var duplicate = false;
                    var column = false;
                    var duplicateArray = [];
                    for(var row in data) {
                        if(row == 0){
                            for(var item in data[row]) {
                                var value = data[row][item];
                                value = value.replace(/[^\w\s]/gi,'');
                                if(col.indexOf(value) > -1){
                                    duplicate = true;
                                    duplicateArray.push(value);
                                }
                                col.push(value);
                            }
                        }else{
                            break;
                        }
                    }
                    if(duplicate == true && that.fileAdded == true){
                        var error_message =  duplicateArray.toString();
                        that.showAlertBox('error','Duplicate column name',error_message);
                    }
                    if(col.length < 3 && that.fileAdded == true){
                        column = true;
                        var error_message = $('div#columnfourmessage').html();
                        that.showAlertBox('error','Missing column',error_message);
                    }
                    if(duplicate == true || column == true){
                        that.dropZoneObject.removeAllFiles();
                    }
                };
                reader.onerror = function(){ this.showAlertBox('Unable to read ' + file.fileName); }.bind(this);
            },

            saveCity(){
                var cityValue = $('#cityAddValue').val();
                if (cityValue === "") {
                    that.showAlertBox('error','Please enter city name');
                }else{
                    var that = this;
                    this.$Progress.start();
                    axios.post('/api/addCity',{name:cityValue})
                    .then(response => {
                        if(response.status == 200){
                            that.finalcityArray.push({id:response.data.city_id,name:cityValue});
                            that.cityMapped = that.finalcityArray.length;
                            var html = '<li class="catory-value"><a class="dropdown-link" href="javascript:void(0)" onclick="mapCitySelection(\''+response.data.city_id+'\',\''+cityValue+'\',this);">'+cityValue+'</a></li>';
                            $('ul.city_list').find('li:last').each(function(){
                                $(this).after(html);
                            });
                            $("#addCategory").modal("hide");
                            that.showToastBox('success','City has been added');
                            that.$Progress.finsih();
                        }else{
                            that.showAlertBox('error','Something went wrong');
                            that.$Progress.fail();
                        }
                    });
                }
            },
            generateRetailerData(){
                var that = this;
                if(that.$route.query.payroll_id != null)
                {
                    that.payroll_id = that.$route.query.payroll_id;
                }
                this.$Progress.start();
                axios.post("/api/generatePayrollRetailer",{
                    payroll_id:that.payroll_id
                })
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            that.companyType = res.data.companyType;
                            that.payroll = res.data.payroll;
                            that.payrollType = res.data.payrollType;

                            if(that.payroll != null){
                                that.title = that.payroll.name;
                                that.payroll_type = that.payroll.payroll_type;
                                that.payroll_frequency = that.payroll.payroll_frequency;
                                if(that.payroll.payroll_frequency == 'ONETIME'){
                                    that.onetime_date = that.payroll.onetime_date;
                                }else{
                                    that.from_date = that.payroll.from_date;
                                    that.to_date = that.payroll.to_date;
                                }
                            }

                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to load form data');
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    });
            }
        },
        created() {
        },
        mounted(){
            var that = this;
            this.initDropZone();
            $("#drop").dropzone();
            $(".drozone-label").tooltip({
                html	: true,
                template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner large"></div></div>',
            });
            $(window.document).on('show.bs.modal', '.modal', function (event) {
                var zIndex = 1040 + (10 * $('.modal:visible').length);
                $(this).css('z-index', zIndex);
                setTimeout(function() {
                    $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
                }, 0);
            });
            this.generateRetailerData();
        }
    }
</script>
